import { render, staticRenderFns } from "./SwimmingCompetition3.vue?vue&type=template&id=3f3612e9&"
import script from "./SwimmingCompetition3.vue?vue&type=script&lang=js&"
export * from "./SwimmingCompetition3.vue?vue&type=script&lang=js&"
import style0 from "./SwimmingCompetition3.vue?vue&type=style&index=0&id=3f3612e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports